<template>
  <div>
    <div class="card-item" :class="{ 'card-item--active': isEnqueteInTarja }">
      <!-- Body -->
      <div class="card-item__body">
        <span class="card-item__title" style="font-weight: 600">
          {{ item.dsc_titulo_enquete }}
        </span>

        <span v-if="item.dsc_descricao_enquete" class="card-item__info">
          {{ item.dsc_descricao_enquete }}
        </span>

        <!-- Status + alternativas inline -->
        <div class="d-flex align-center flex-wrap" style="gap: 8px">
          <span v-if="item.flg_encerrado" class="card-item__status card-item__status--closed">
            Encerrada em {{ formatDate(item.updated_at) }} · {{ formatHour(item.updated_at) }}
          </span>
          <span class="card-item__info">{{ item.enquete_opcoes.length }} alternativas</span>
        </div>

        <!-- Meta row -->
        <div class="card-item__meta">
          <span class="meta-source">{{ portalDisplayName(item.tenant_id_backstage) }}</span>
          <span class="meta-separator">·</span>
          <span>{{ formatDate(item.created_at) }}</span>
          <span class="meta-separator">·</span>
          <span>{{ formatHour(item.created_at) }}</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="card-item__actions">
        <v-tooltip left color="surface_neutral_selected">
          <template v-slot:activator="{ on, attrs }">
            <div
              class="card-action-box card-action-box--delete"
              v-bind="attrs"
              v-on="on"
              @click.prevent="removerEnqueteExibicao"
             role="button" aria-label="Remover enquete da exibição">
              <v-icon>mdi-arrow-left</v-icon>
            </div>
          </template>
          <span>Remover enquete da exibição</span>
        </v-tooltip>

        <DownloadEnqueteQRCODE :item="item" />
        <ModalEditarOpcoesEnquete :item="item" @option-updated="onOptionUpdated" />
      </div>
    </div>

    <!-- Tarja controls row -->
    <div class="card-tarja-actions">
      <ModalExibirEnqueteNaTarja
        v-if="!isEnqueteInTarja"
        :codProducao="$store.state.producoes.selectedProducao.cod_producao"
        :id_enquete="item.id"
        :enqueteItem="item"
        @change="handleTarjaChange"
      />
      <ModalExibirEnqueteNaTarjaFullScreen
        v-if="!isEnqueteInTarja"
        :codProducao="$store.state.producoes.selectedProducao.cod_producao"
        :id_enquete="item.id"
        :isDisabled="!hasFullscreenMode"
        @change="handleTarjaChange"
      />
      <ModalExibirEnqueteNaTarjaQRCODE
        v-if="!isEnqueteInTarja"
        :codProducao="$store.state.producoes.selectedProducao.cod_producao"
        :id_enquete="item.id"
        :enqueteItem="item"
        :hasModeAvailable="hasQRCodeComponentMode"
        @change="handleQRCodeChange"
        @force-refresh="forceRefresh"
      />
      <ModalRemoverEnqueteDaTarja
        v-if="isEnqueteInTarja"
        :codProducao="$store.state.producoes.selectedProducao.cod_producao"
        :idEnquete="item.id"
        @change="handleTarjaRemove"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import { getAvailableModes } from "@/config/enqueteComponentMap";
import ModalEditarOpcoesEnquete from "@/components/Modal/Enquetes/ModalEditarOpcoesEnquete.vue";
import ModalExibirEnqueteNaTarja from "@/components/Modal/Enquetes/ModalExibirEnqueteNaTarja.vue";
import ModalExibirEnqueteNaTarjaFullScreen from "@/components/Modal/Enquetes/ModalExibirEnqueteNaTarjaFullScreen.vue";
import ModalExibirEnqueteNaTarjaQRCODE from "@/components/Modal/Enquetes/ModalExibirEnqueteNaTarjaQRCODE.vue";
import ModalRemoverEnqueteDaTarja from "@/components/Modal/Enquetes/ModalRemoverEnqueteDaTarja.vue";
import DownloadEnqueteQRCODE from "@/components/Modal/Enquetes/DownloadEnqueteQRCODE.vue";

export default {
  props: {
    item: Object,
    getEnqueteEmExibicao: Function,
    getEnquetesProducao: Function,
    pageAprovada: Number,
    cod_pasta: Number,
  },
  components: {
    ModalEditarOpcoesEnquete,
    ModalExibirEnqueteNaTarja,
    ModalExibirEnqueteNaTarjaFullScreen,
    ModalExibirEnqueteNaTarjaQRCODE,
    ModalRemoverEnqueteDaTarja,
    DownloadEnqueteQRCODE,
  },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      dialogRemoverNoticiaModerada: false,
      isChangingTarja: false,
    };
  },
  computed: {
    ...mapGetters({
      tarjaParams: "tarja_enquete/getTarjaParams",
      configTarja: "tarja_enquete/getConfigTarja",
      portalDisplayName: "portais/getPortalDisplayName",
    }),
    isEnqueteInTarja() {
      return this.configTarja && this.configTarja.id_enquete_tarja === this.item.id;
    },
    codProducao() {
      return this.$store.state.producoes.selectedProducao?.cod_producao;
    },
    availableModes() {
      return getAvailableModes(this.codProducao);
    },
    hasFullscreenMode() {
      return this.availableModes.fullscreen;
    },
    hasQRCodeComponentMode() {
      return this.availableModes.qrcode;
    },
  },
  methods: {
    ...mapActions({
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
      updateEnqueteQrCodeFlag: "enquetes/updateEnqueteQrCodeFlag",
      setQRCodeMode: "producoes/setQRCodeMode",
    }),
    formatDate,
    formatHour,
    async showModalImagem(midia_url_aprovadas) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async handleTarjaChange(payload) {
      const preserveQRCode = payload?.preserveQRCode || false;
      await this.changeIsSelectedToTarja(this.item.id, preserveQRCode);
    },
    async handleTarjaRemove() {
      await this.changeIsSelectedToTarja(null, false);
    },
    async changeIsSelectedToTarja(id_enquete, preserveQRCode = false) {
      if (this.isChangingTarja) return;

      this.isChangingTarja = true;
      try {
        const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;

        if (id_enquete && !preserveQRCode) {
          await this.setQRCodeMode({
            enabled: false,
            combined: false
          });

          await this.updateEnqueteQrCodeFlag({
            cod_producao,
            qr_code: false,
            qr_code_combined: false
          });
        }

        await apiClient.patch(`setEnqueteExibicaoTarja/${cod_producao}`, {
          id_enquete,
        });

        await this.getConfigTarja({ cod_producao });

      } catch (error) {
        console.error(error);
        this.$toast.error("Erro ao exibir enquete na tarja");
      } finally {
        this.isChangingTarja = false;
      }
    },
    async handleQRCodeChange() {
      try {
        await this.changeIsSelectedToTarja(this.item.id, true);

        await this.forceRefresh();
      } catch (error) {
        console.error('Error handling QR Code change:', error);
        this.$toast.error('Erro ao configurar QR Code');
      }
    },
    async forceRefresh() {
      try {
        this.$emit("reload-enquetes");

        if (this.getEnqueteEmExibicao) {
          await this.getEnqueteEmExibicao({
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          });
        }
      } catch (error) {
        console.error('Error in force refresh:', error);
      }
    },
    onOptionUpdated() {
      this.$emit('reload-enquetes');
    },
    async removerEnqueteExibicao() {
      try {
        const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;

        await this.setQRCodeMode({
          enabled: false,
          combined: false
        });

        await this.updateEnqueteQrCodeFlag({
          cod_producao,
          qr_code: false,
          qr_code_combined: false
        });

        await apiClient.put(`/enquetes/exibicao`, {
          cod_producao,
          id_enquete: null,
        });

        await this.getEnqueteEmExibicao({
          cod_producao,
        });

        this.$emit("reload-enquetes");
      } catch (error) {
        console.error(error);
        this.$toast.error("Houve um erro ao remover a enquete da exibição");
      }
    },
  },
};
</script>
